<template>
    <div :class="$style.wrapper">
        <DataTable :actions="true"
            :data="rolesList"
            :columns="tableConfig"
            :is-loading="isLoading"
            @on-page-change="pageChange">
        </DataTable>
    </div>
</template>

<script>
    import DataTable from 'Components/DataTable'
    import loadingMixin from 'Mixins/loadingMixin'
    import tableConfig from './rolesTable'
    import {getRolesByUserID} from '../../api'
    export default {
        name: "userRoles",
        mixins: [loadingMixin],
        props: ['value', 'readonly', 'isManagerViewing', 'isStaffViewing'],
        components: {
            DataTable
        },
        data() {
            return {
                sorting: {
                    key: 'Task',
                    order: 'asc'
                },
                pagination: {
                    perPage: 10,
                    page: 1,
                    total: 0
                },
                tableConfig,
                rolesList: []
            }
        },
        computed: {
            userData() {
                return this.$store.state.user.user;
            }
        },
        watch: {
        },
        created() {
            this.getData()
        },
        methods: {
            getData() {
                setTimeout(() => {
                    this.showLoader();
                    const filters = {};
                    filters.staffId = this.value.data.userId;
                    const { key, order } = this.sorting;
                    const { perPage, page } = this.pagination;
                    const data = {
                        filterjson: {
                            filter: [filters],
                            sort: [{ key, order }],
                            paging: [
                                {
                                    startIndex: page,
                                    pageSize: perPage
                                }
                            ]
                        }
                    };
                    getRolesByUserID(data)
                        .then(this.handleResponse)
                        .catch(this.handleError)
                },
                50
                );
            },
            pageChange(page) {
                this.pagination.page = page;
                this.getData()
            },
            handleResponse(response) {
                this.rolesList = response.data;
                this.hideLoader();
            },
        }
    }
</script>

<style lang="scss" module>
    .wrapper {
        :global {
            .text-danger {
                display: block;
            }
        }
    }
</style>
